import styled from '@emotion/styled';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';
import { withConfig } from 'src/withConfig';

export const RunnerCell = styled('div', { label: 'RunnerCell' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 12px;
    justify-content: start;
    overflow: hidden;
    padding: 8px 12px;
`;

export const TrapCellRaceBox = styled('div', { label: 'TrapCellRaceBox' })`
    align-items: center;
    display: flex;
    flex: 0 0 32px;
    height: 32px;
    justify-content: center;
`;

export const TrapWrapperNextRaces = styled(Trap, { label: 'TrapWrapperNextRaces' })`
    height: 24px;
    width: 24px;
`;

export const RacerName = withConfig(theme => styled('div', { label: 'RacerName' })`
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.small};
    justify-content: center;
    line-height: 1.3334;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`);

export const SelectionWrapper = styled(Selection, { label: 'SelectionWrapper' })`
    align-self: stretch;
`;
